import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const CopySpacePermissionsForLegacyNewSpace: LoadableType<{}> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CopySpacePermissionsForLegacyNewSpace" */ '../src/CopySpacePermissionsForLegacyNewSpace.tsx'
			)
		).CopySpacePermissionsForLegacyNewSpace,
	name: 'CopySpacePermissionsForLegacyNewSpace',
});
